import React from "react";
import TimeField from "react-simple-timefield";
const ScheduleVisit = ({ visit, schIndex, vIndex, removeVisitToReservationSchedule, updateReservationProps, enabled }) => {
  return (
    <div
      className={`reservation-schedule-visit ${
        visit.repeat === true ? "callout callout-warning" : "callout callout-danger"
      }`}
    >
      <div className="reservation-schedule-visit__meta">
        <span>{visit.name}</span>
      </div>
      <div className="reservation-schedule-visit__actions">
        <span>
          <i className="fa fa-clock-o " style={{ color: "black", marginRight: 5 }} />
          <TimeField
            style={{
              border: "0px",
              borderBottom: "1px solid #555",
              width: 40,
              borderRadius: 3
            }}
            value={visit.time}
            disabled={!enabled}
            onChange={T => {
              updateReservationProps([{ prop: "reservationSchedule." + schIndex + ".schedule.visits." + vIndex + ".time", value: T }]);
            }}
          />
        </span>
        {enabled ? (
          <i
            onClick={() => {
              removeVisitToReservationSchedule(schIndex, vIndex);
            }}
            className="fa fa-times-circle "
            style={{ color: "red", marginLeft: 20, justifySelf: "flex-end" }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ScheduleVisit;
